import ReactPlayer from "react-player";

const FILE_TYPES = {
  youtube: { label: "YouTube", icon: "▶️" },
  vimeo: { label: "Vimeo", icon: "▶️" },
  mp4: { label: "Video", icon: "🎬" },
  hls: { label: "Stream", icon: "📺" },
};

export default function VideoPlayer({ url, type = "youtube", title, onProgress, onComplete, width = "100%", height = "100%" }) {
  if (!url) {
    return (
      <div className="w-full aspect-video bg-slate-900 flex items-center justify-center text-slate-500">
        <div className="text-center">
          <div className="text-4xl mb-2">🎬</div>
          <p className="text-sm">No video available for this lecture</p>
        </div>
      </div>
    );
  }

  const handleProgress = (state) => {
    if (onProgress) onProgress(state);
    // Auto-mark complete at 90% watched
    if (onComplete && state.played >= 0.9) {
      onComplete();
    }
  };

  return (
    <div className="w-full aspect-video bg-slate-900 relative overflow-hidden">
      <ReactPlayer
        url={url}
        width={width}
        height={height}
        controls
        playing={false}
        onProgress={handleProgress}
        progressInterval={5000}
        config={{
          youtube: { playerVars: { modestbranding: 1, rel: 0 } },
          vimeo: { byline: false, portrait: false },
          file: {
            attributes: { controlsList: "nodownload" },
          },
        }}
        style={{ position: "absolute", top: 0, left: 0 }}
      />
      {title && (
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 pointer-events-none">
          <p className="text-white text-sm font-medium">{title}</p>
        </div>
      )}
    </div>
  );
}
